export class SearchClientModel{
  file:any;
  idNumber:string;
  branchNumber:string;
  action:string;
  selectedLoan:string;
}

